import { useFormat } from '@ideavivat/vivat-2';
import useSubJob from '@/use/useSubJob';
import usePurchaseRequest from '@/use/usePurchaseRequest';
import {
  _increment,
  production_type,
  job_no,
  drawing_no,
  description,
  material_code,
  unit,
  status,
  target_date,
} from '@/table/Job/SubJob/base';

// const { translate, classMap } = usePurchaseRequest();
const { translateSubJobStatus, statusClassMap } = useSubJob();

export default {
  types: {
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment,
    production_type,
    job_no,
    drawing_no,
    description,
    material_code,
    status,
    target_date,
    amount: {
      name: 'จำนวน / ซื้อแล้ว',
      width: '6rem',
      class: 'text-right',
    },
    unit,
    remarks: {
      name: 'หมายเหตุ',
      width: '5rem',
      class: 'text-center',
    },
  },
};
